import React from 'react';
import TicketReply from '../ReusedComponents/TicketReply'
import { useParams, useHistory } from 'react-router-dom'

export default function AdminTicket() {
    const history = useHistory();
    const { sid, uid } = useParams();

    // On a direct visit/refresh there is no navigation state, so guard it —
    // reading .userType off undefined was crashing the whole page.
    const navState = history.location.state || {};

    return (
        <div className="totalTicketingModule">

            <TicketReply
                userType={navState.userType || "admin"}
                title={navState.title || "Ticket Details"}
                options={[
                    { title: "Create Ticket", url: `/tickets/admin/creating/${sid}/${uid}` },
                    { title: "My Tickets", url: `/tickets/admin/mytickets/${sid}/${uid}` },
                    { title: "Reports", url: `/tickets/admin/reports/${sid}/${uid}` },
                    { title: "Email Alerts", url: `/tickets/admin/email-alerts/${sid}/${uid}` }
                ]}
            />

        </div>
    )
}